import React from "react";
import "./footer.css";
// import logo from "../../assets/logo.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer__container container">
        {/* <h1 className="footer__title">AP</h1> */}
        {/* <img src={logo} alt="Logo" width= "40px"/> */}
        <ul className="footer__list">
          <li>
            <a href="#about" className="footer__link">
              About
            </a>
          </li>

          <li>
            <a href="#skills" className="footer__link">
              Skills
            </a>
          </li>

          <li>
            <a href="#qualification" className="footer__link">
              Qualification
            </a>
          </li>

          <li>
            <a href="#projects" className="footer__link">
              Projects
            </a>
          </li>

          <li>
            <a href="https://blog.alipeiro.xyz/" className="footer__link">
              blog
            </a>
          </li>
        </ul>

        {/* <div className="footer__social">
          <a
            href="https://www.facebook.com/"
            className="footer__social-link"
            target="_blank"
          >
            <i class='bx bxl-github' ></i>
          </a>

          <a
            href="https://www.instagram.com/"
            className="footer__social-link"
            target="_blank"
          >
            <i class='bx bxl-instagram'></i>
          </a>
          <a
            href="https://twitter.com/"
            className="footer__social-link"
            target="_blank"
          >
            <i class='bx bxl-twitter' ></i>
          </a>
        </div> */}

        {/* <span className="footer__copy">
          &#169; Ali Peiro. All rights reserved.
        </span> */}
        <span className="footer__text">
          Made with <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"></path></svg> by Ali
        </span>
      </div>
    </footer>
  );
};

export default Footer;
